import React from "react";
import { Route, Routes } from "react-router-dom";
import BulkDownload from "../pages/bulkDownload/bulkDownload";

export default function BulkDownloadRoutes() {
  return (
    <Routes>
      <Route path="" element={<BulkDownload />} />
    </Routes>
  );
}
